var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-switcher"},[_c('div',{staticClass:"lang-switcher__current"},[_c('lang-item',{attrs:{"locale":_vm.invertedLocale}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }